import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ChartOverview from "../components/ChartOverview";
const ChartOverviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Chart Overview" />

        <ChartOverview />

      </MasterLayout>
    </>
  );
};

export default ChartOverviewPage;
